/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Subhead, Content, Group, Copy, Title, Form, 
  Grid, GridSet, GridItem, TextField, EditInfoCTA, EmptyState, url
} from '@insticator/insticator-ui'; // iui-material
// utils
import { log } from '@insticator/insticator-ui'; // iui-utils
// styles
import styles from 'pages/dashboard/myprofile/myprofile_styles';
import injectSheet from 'react-jss';



/* ========== ~~~~~~~~~~ MY PROFILE ~~~~~~~~~~ ========== */
class MyProfile extends Component {
    constructor(props){
        super(props);
        this.formName = 'personalInformationForm';
    }
    componentDidMount() {
        // Populates form data with the data from session status.
        // The data will be stored in session status if user logs in by clicking on log in button
        // In that case session status is pupulated with the auth data before the component mounts
        this.props.receiveFormData(this.formName, this.getFormCallData(false))
    }
    componentDidUpdate(prevProps) {
        if (prevProps.userEmail !== this.props.userEmail) this.props.receiveFormData(this.formName, this.getFormCallData(false))
    }
    handleSave = () => {
        this.props.updateUserInfoWithValidation(this.props.fields, this.getFormCallData(), this.props.userUUID, this.processSuccessfulUpdate, this.processFailedUpdate)
    };
    processSuccessfulUpdate = response => {
        log('UPDATED RESPONSE. SUCCESS:', response.data)
        this.props.setAuthData(response)
    };
    processFailedUpdate = errorResponse => {
        log('UPDATED RESPONSE. FAIL:', errorResponse)
    };

    getFormCallData = (isFormData=true) => ({
        firstName: isFormData ? this.props.fields.fname.value : this.props.userFirstName,
        lastName: isFormData ? this.props.fields.lname.value : this.props.userLastName,
        email: isFormData ? this.props.fields.email.value: this.props.userEmail,
        phoneNumber: isFormData ? this.props.fields.phone.value: this.props.userPhoneNumber,
    });

    componentWillUnmount() {
        this.props.resetForm(this.formName)
    }

    redirectToUsersV2 = () => window.open(`https://publisher-portal.${url.baseURL}/dashboard/settings/account`, '_self')

    render() {
        const { fname, lname, phone, email, } = this.props.fields;
        return (
          <Page klass={`myprofile ${this.props.classes.myprofile}`}>
            <Subhead>
              <h1>My Profile</h1>
            </Subhead>
            <Content>
              <EmptyState 
                graphicName={'error-404'} 
                buttonText={'Go to My Profile'} 
                bodycopy={<p>My Profile has been moved to <b>Publisher Portal V2 (Beta)</b></p>} 
                buttonClick={() => this.redirectToUsersV2()} 
                buttonName={'gotoppv2users'}
              />
            </Content>
          </Page>
        )
        return(
            <Page name={`myprofile`} klass={this.props.classes.myprofile}>
                <Form name={`personalInformationForm`} editable={this.props.editable} processing={this.props.savingData}>
                    <Subhead>
                        <h1>My Profile</h1>
                    </Subhead>
                    <Content>
                        <Copy name={`page-copy`}>
                            <Title variant={'withctas'}>
                                <h2>Personal Information</h2>
                                {this.props.mocked ? null : <EditInfoCTA formName={this.formName}
                                             editable={this.props.editable}
                                             savingData={this.props.savingData}
                                             saveFormData={this.handleSave}
                                />}
                            </Title>
                        </Copy>
                        <Group name={`page-details`}>
                            <Grid type={`fields`}>
                                <GridSet direction={`horizontal`}>
                                    <GridItem><TextField type={`text`} formName={this.formName} name={`fname`} placeholder={`First Name`} label={`First Name`} info={``} value={fname.value} valid={fname.valid} disabled={this.props.mocked} required /></GridItem>
                                    <GridItem><TextField type={`text`} formName={this.formName} name={`lname`} placeholder={`Last Name`} label={`Last Name`} info={``} value={lname.value} valid={lname.valid} disabled={this.props.mocked} required /></GridItem>
                                </GridSet>
                                <GridSet direction={`horizontal`}>
                                    <GridItem><TextField type={`text`} formName={this.formName} name={`email`} placeholder={`Email`} label={`Email`} info={``} value={email.value} valid={email.valid} disabled={true} required /></GridItem>
                                </GridSet>
                                <GridSet>
                                    <GridItem><TextField type={`text`} formName={this.formName} name={`phone`} placeholder={`Phone Number`} label={`Phone Number`} info={``} value={phone.value} valid={phone.valid} disabled={this.props.mocked} required /></GridItem>
                                </GridSet>
                            </Grid>
                        </Group>
                    </Content>
                </Form>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(MyProfile);
